import { render, staticRenderFns } from "./LayoutCard.vue?vue&type=template&id=0e248260&scoped=true"
import script from "./LayoutCard.vue?vue&type=script&lang=js"
export * from "./LayoutCard.vue?vue&type=script&lang=js"
import style0 from "./LayoutCard.vue?vue&type=style&index=0&id=0e248260&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e248260",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e248260')) {
      api.createRecord('0e248260', component.options)
    } else {
      api.reload('0e248260', component.options)
    }
    module.hot.accept("./LayoutCard.vue?vue&type=template&id=0e248260&scoped=true", function () {
      api.rerender('0e248260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layouts/LayoutCard.vue"
export default component.exports